<script lang="ts">
  // Die Liste hinter einem gebündelten „Läuft gerade"-Eintrag (lib/laeuft.ts
  // buendle): „Claude 2 arbeiten" → welche Chats, ein Klick springt hin.
  // Statusleiste und Telefon-Zeile teilen sie; sie klappt über den Anker,
  // weil beide am unteren Rand sitzen.
  import { anchoredPopover } from "./anchored-popover";
  import { t } from "./i18n.svelte";
  import type { Laeuft } from "./laeuft";
  import { portal } from "./portal";

  interface Props {
    eintraege: Laeuft[];
    anker: HTMLElement | null;
    onwahl: (pfad: string) => void;
    onzu: () => void;
  }
  let { eintraege, anker, onwahl, onzu }: Props = $props();

  let liste = $state<HTMLDivElement | undefined>(undefined);
  $effect(() => {
    liste?.querySelector<HTMLButtonElement>("button")?.focus({ preventScroll: true });
  });

  function taste(e: KeyboardEvent): void {
    if (e.key === "Escape") {
      e.preventDefault();
      onzu();
      anker?.focus();
      return;
    }
    if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;
    e.preventDefault();
    const knoepfe = [...(liste?.querySelectorAll<HTMLButtonElement>("button") ?? [])];
    const i = knoepfe.indexOf(document.activeElement as HTMLButtonElement);
    knoepfe[(i + (e.key === "ArrowDown" ? 1 : knoepfe.length - 1)) % knoepfe.length]?.focus();
  }
</script>

<button type="button" aria-label={t("common.close", "Schließen")} use:portal class="fixed inset-0 z-30 cursor-default" onclick={onzu}></button>
<div
  bind:this={liste}
  role="menu"
  tabindex="-1"
  onkeydown={taste}
  use:portal
  use:anchoredPopover={{ anchor: anker, gap: 6, placement: "auto" }}
  class="border-border bg-bg-elev/95 z-40 grid max-w-[min(22rem,calc(100vw-1.5rem))] min-w-56 overflow-y-auto rounded-lg border p-1 shadow-xl backdrop-blur-xl t-meta"
>
  {#each eintraege as l (l.id)}
    <button
      type="button"
      role="menuitem"
      class="hover:bg-bg-muted/60 focus-visible:bg-bg-muted/60 flex min-w-0 items-center gap-2 rounded px-2 py-1.5 text-left outline-none"
      title={l.titel}
      onclick={() => {
        onzu();
        onwahl(l.pfad);
      }}
    >
      <span class="punkt {l.ton}" aria-hidden="true"></span>
      <span class="text-fg min-w-0 flex-1 truncate">{l.bezeichnung ?? l.name}</span>
      <span class="shrink-0 {l.ton === 'warn' ? 'text-warning' : 'text-fg-subtle'}">{l.was}</span>
    </button>
  {/each}
</div>

<style>
  .punkt {
    width: 0.45rem;
    height: 0.45rem;
    border-radius: 50%;
    flex: none;
    background: var(--fg-subtle);
  }
  .punkt.laeuft {
    background: var(--color-laeuft);
  }
  .punkt.warn {
    background: var(--warning);
  }
</style>
